import React from 'react';
import { NotAuthorised } from '@ihsm/ui-shared';

export const DeniedAccess = (): JSX.Element => {
  return <NotAuthorised />;
};
